module.exports = __webpack_public_path__ + "static/media/fm.4b45aa24.svg";